'use client'

import NextLink from 'next/link'
import { useRouter } from 'next/navigation'

import { Homepage } from '@ui/shared/pages'
import { buildUrl } from '@helper/utils/format'

export default function ExplorePage() {
  const router = useRouter()
  const signUpHref = buildUrl('account', '/daftar').href

  return (
    <main className='bg-neutral-black min-h-dvh w-full pt-4 pb-20'>
      <Homepage
        type='web'
        renderBookThemeAction={(theme) => ({
          type: 'link',
          renderWrapper: (children) => <NextLink href={`/explore/cari?bookThemeId=${theme.id}`}>{children}</NextLink>,
        })}
        renderLibrarySliderAction={() => ({
          type: 'link',
          renderWrapper: (children) => <a href={signUpHref}>{children}</a>,
        })}
        renderBookCollectionAction={(collection) => ({
          type: 'link',
          renderWrapper: (children) => (
            <NextLink href={`/explore/seri-dan-kompilasi/${collection.slug}`}>{children}</NextLink>
          ),
        })}
        renderBookModalAction={() => ({
          type: 'link',
          renderWrapper: (children) => <a href={signUpHref}>{children}</a>,
        })}
        renderLessonModuleModalAction={() => ({
          type: 'link',
          renderWrapper: (children) => <a href={signUpHref}>{children}</a>,
        })}
        onSearch={(value) => {
          if (value) {
            router.push(`/explore/cari?q=${encodeURIComponent(value)}`)
          } else {
            router.push('/explore/cari')
          }
        }}
        onBookTagClick={(type, id) => {
          if (!id) return
          const paramMap: Record<string, string> = {
            theme: 'bookThemeId',
            level: 'bookLevelId',
            author: 'contributorId',
            publisher: 'publisherId',
          }
          const param = paramMap[type]
          if (param) router.push(`/explore/cari?${param}=${id}`)
        }}
        onModuleTagClick={(type, id) => {
          if (!id) return
          const paramMap: Record<string, string> = {
            grade: 'gradeId',
            curriculum: 'curriculumId',
            contributor: 'contributorId',
          }
          const param = paramMap[type]
          if (param) router.push(`/explore/cari?${param}=${id}`)
        }}
      />
    </main>
  )
}
